import type { CartOrderSummaryConfig } from '#types/config/components/cart/orderSummary'
import type { RecursivePartial } from '#types/utils'

export default {
  orderSummary: {
    subtotal: 'body-3',
  },
} satisfies RecursivePartial<CartOrderSummaryConfig>
